"use client";

import React from "react";
import { MapPin, Phone, Mail, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}><Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Home</Link></li>
        <li data-index={1}><Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Services</Link></li>
        <li data-index={2}><Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Calculators</Link></li>
        <li data-index={3}><Link to="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-background border-t border-border pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <img src="https://legal-spider.websiteshop.au/wp-content/uploads/2026/04/SLA-Logo-1.png" alt="SLA Finance Group Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Smarter Finance Solutions, Tailored To You. We provide expert guidance for home loans, business finance, and equipment funding.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6">Quick Links</h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6">Contact Us</h3>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="size-5 shrink-0 text-primary" />
                <span>Level 26/44 Market St, Sydney NSW 2000</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="size-5 shrink-0 text-primary" />
                <Link to="tel:+61455074530" className="hover:text-foreground transition-colors">+61 455 074 530</Link>
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="size-5 shrink-0 text-primary" />
                <Link to="mailto:sash@slafinance.com.au" className="hover:text-foreground transition-colors">sash@slafinance.com.au</Link>
              </li>
            </ul>
          </div>

          {}
          

        </div>

        {}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[12px] text-muted-foreground text-center md:text-left">© 2026 SLA Finance Group. All rights reserved. 2026 Website Build by <Link to="https://www.websiteshop.com.au" newTab className="text-[#c9a538] hover:underline">Website Shop</Link>.</p>
          <div className="flex items-center gap-4 text-[12px] text-muted-foreground">
            
            <Link to="#" className="hover:text-foreground transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-foreground transition-colors">Legal Disclaimer</Link>
          </div>
        </div>
      </div>
    </section>;
}